import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import { TemplateService } from '../../../services/template.service';
import * as _ from 'lodash';

import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-download-request-inc',
  templateUrl: './download-request-inc.component.html',
  styleUrls: ['./download-request-inc.component.scss'],
  providers: [TemplateService]
})
export class DownloadRequestIncComponent implements OnInit, OnDestroy {
  calendarLocale = CALENDAR_LOCALE.TH;
  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  minDate: Date;
  maxDate: Date;
  taxID = '';
  documentNumber = '';
  email = '';
  isSuccess = false;
  loading = false;
  error = {};
  requestType = 0;
  buyerName: string;
  documentType: any;
  allDocumentType = [];
  rdDocumentType: any;
  selectedRdDocumentType: any;

  private subs = new SubSink();
  private tableCol: any[];
  private company_type: string;
  private errorMessage: string;

  constructor(
    private downloadService: DownloadService,
    private template: TemplateService,
    private translate: TranslateService) {}

  ngOnInit() {
    // this.loadInput();
    // this.loadDropdown();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.rdDocumentType = this.template.getDropdown();
  }

  loadTexts() {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateTaxID(taxID) {
    if (taxID == null || taxID === '') {
      return true;
    }
    return this.taxID.length === 13;
  }

  validateInput() {
    this.validateEmail(this.email) === false
      ? (this.error['email'] = true)
      : delete this.error['email'];
    return this.error;
  }

  submit() {
    this.error = {};
    let errorField = [];
    this.errorMessage = null;
    if (this.translate.currentLang === 'en') {
      if (!isEmpty(this.validateInput())) {
        errorField.push('Email is invalid form. It needs to be in xxx@xxx.com form only.');
      }
      if (this.buyerName == null || this.buyerName.length == 0) {
        errorField.push('buyer name ');
      }

      if (this.documentNumber == null || this.documentNumber.length == 0) {
        errorField.push('document number ');
      }

      if (this.selectedRdDocumentType == undefined) {
        errorField.push('document Type')
      }
      if (errorField.length > 0) {
        this.errorMessage = 'Please fill ' + errorField.join(',') + ' correctly.';
        return;
      }
    }else{
      if (!isEmpty(this.validateInput())) {
        errorField.push('อีเมล์ไม่ถูกต้อง ต้องระบุอีเมล์ในรูปแบบของ xxx@xxx.com เท่านั้น');
      }
      if (this.buyerName == null || this.buyerName.length == 0) {
        errorField.push('ชื่อผู้ซื้อ');
      }

      if (this.documentNumber == null || this.documentNumber.length == 0) {
        errorField.push('เลขที่เอกสาร');
      }

      if (this.selectedRdDocumentType == undefined) {
        errorField.push('ประเภทเอกสาร')
      }
      if (errorField.length > 0) {
        this.errorMessage = 'โปรดกรอก' + errorField.join(', ') + ' ให้ครบถ้วน';
        return;
      }

    }
    // this.company_type = '';
    // if (this.requestType === 1) {
    //   this.company_type = 'IQVIA INC. - Thailand';
    // }else {
    //   this.company_type = 'IQVIA (Thailand) Co., Ltd.';
    // }

    const data = {
      rd_doc_type: this.selectedRdDocumentType,
      buyer_name: this.buyerName,
      document_number: this.documentNumber,
      document_type_id: _.isNil(this.documentType)
        ? this.documentType
        : _.uniq(this.allDocumentType),
      document_start_date: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '',
      document_end_date: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '',
      email: this.email,
      seller_name: 'IQVIA INC. - Thailand'
    };
    this.loading = true;
    this.downloadService.createDocumentRequest(data).subscribe(
      () => {
        this.isSuccess = true;
        this.loading = false;
      }
    );
  }

  reloadPage() {
    location.reload();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-request-inc/download-request-inc.component.ts